var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08333 4.71297H12.0833M5.08333 7.04631H8.58333M1 8.22075C1 9.4652 1.87344 10.5494 3.10544 10.7306C3.98356 10.8598 4.871 10.9585 5.76778 11.0254C6.04 11.0456 6.28889 11.1888 6.44056 11.4151L8.58333 14.6296L10.7261 11.4151C10.8013 11.3033 10.9009 11.2101 11.0175 11.1426C11.1341 11.0751 11.2645 11.035 11.3989 11.0254C12.2896 10.9589 13.1776 10.8606 14.0612 10.7306C15.2932 10.5494 16.1667 9.46597 16.1667 8.21997V3.53931C16.1667 2.29331 15.2932 1.20986 14.0612 1.02864C12.2474 0.762418 10.4166 0.629063 8.58333 0.629641C6.72289 0.629641 4.89356 0.765752 3.10544 1.02864C1.87344 1.20986 1 2.29408 1 3.53931V8.21997V8.22075Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chatWhite.f6c264545684c6a7574348d558379366.svg";
export { ForwardRef as ReactComponent };